import React from 'react';
import {Route, RouteProps} from 'react-router-dom';
import PageLogin from "../PageLogin/PageLogin";
import pageVerification from "../PageVerification/PageVerification";

interface Props extends RouteProps{
  isAuth? : boolean;
  isVerified? : boolean;
}

const ProtectedRoute = ({isAuth, isVerified, ...routeProps} : Props) => {
  if(isAuth){
    if (isVerified){
      return <Route {...routeProps} />
    } else return <Route path='/' component={pageVerification}/>
  } else return <Route path='/' component={PageLogin}/>
}

export default ProtectedRoute;
